/* eslint-disable import/export */
import PageHeader from './PageHeader';
export * from './PageHeader';
export default PageHeader;